export default "__VITE_ASSET__Bs9yB75o__"